module.exports = require("core-js/library/fn/array/from");


//////////////////
// WEBPACK FOOTER
// external "core-js/library/fn/array/from"
// module id = 6
// module chunks = 0